import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { assertSupabaseEnv } from "./lib/env-check";
import { supabase } from "./integrations/supabase/client";

assertSupabaseEnv();

// Supabase OAuth bootstrap:
// 1) If the URL hash contains a Supabase OAuth fragment (#access_token=…&refresh_token=…),
//    explicitly set the session via supabase.auth.setSession before React mounts.
// 2) Strip the hash via history.replaceState so Safari / eID extension can't crash
//    on "'#access_token=…' is not a valid selector".
// 3) Only then render the app, so ProtectedRoute/useAuth see a valid session.
async function bootstrap() {
  if (typeof window !== "undefined") {
    const { hash, href } = window.location;
    if (hash) {
      const normalized = hash.toLowerCase();
      const looksLikeSupabaseOAuth =
        normalized.startsWith("#access_token=") || normalized.includes("access_token=");
      if (looksLikeSupabaseOAuth) {
        try {
          const params = new URLSearchParams(hash.substring(1));
          const access_token = params.get("access_token") ?? undefined;
          const refresh_token = params.get("refresh_token") ?? undefined;

          if (access_token && refresh_token) {
            try {
              await supabase.auth.setSession({ access_token, refresh_token });
            } catch {
              // ignore: don't block render if setSession fails
            }
          }

          try {
            const url = new URL(href);
            url.hash = "";
            window.history.replaceState(null, "", url.toString());
          } catch {
            // ignore
          }
        } catch {
          // ignore: better to do nothing than to crash again
        }
      }
    }
  }

  createRoot(document.getElementById("root")!).render(<App />);
}

bootstrap();
